export const ColumnWidgetId = 'ColumnWidget';

export enum ColumnWidgetAttributes {
  ELEMENTS = 'columnElements',
  BACKGROUND_COLOR = 'backgroundColor',
}

export enum ColumnWidgetBackgroundColor {
  NONE = 'none',
  LEFT_GRAY = 'leftGray',
  RIGHT_GRAY = 'rightGray',
  GRAY = 'gray',
}
